import { render, staticRenderFns } from "./PartnersJoinWrite.vue?vue&type=template&id=52650fe3&scoped=true&"
import script from "./PartnersJoinWrite.vue?vue&type=script&lang=js&"
export * from "./PartnersJoinWrite.vue?vue&type=script&lang=js&"
import style0 from "./PartnersJoinWrite.vue?vue&type=style&index=0&id=52650fe3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52650fe3",
  null
  
)

export default component.exports